module.exports = __webpack_public_path__ + "static/blog38-2d996fd6506d5b720b4489fbed18214f.png";